import $ from 'jquery';
import SmoothScroll from 'Utils/smoothScroll';
import PubSub from 'Utils/pub-sub';

export const stickyModule = function ({$el, stickyLimit, enterSticky = null, leaveSticky = null}) {
  const el = $($el);
  var isSticky = false;
  var isCbTriggered = false;
  var isDebounced = false;
  var shouldUpdate = true;
  var _scrollHandler;

  const bindScrollEvent = () => {
    _scrollHandler = function (e) {
      if (!isDebounced) {
        handleScrollCb(e);     
      }
    };

    window.addEventListener('scroll', _scrollHandler, {passive: true});
  }

  const unbindScrollEvent = () => {
    window.removeEventListener('scroll', _scrollHandler);
  };

  const destroy = function destroy() {
    unbindScrollEvent();
    el.removeClass('is-sticky');
  };


  const scrollTop = (callback) => {
    isCbTriggered = false;

    SmoothScroll.scrollTo(0, () => {
      isSticky = !isSticky;
      
      if (isCbTriggered) return;

      isCbTriggered = true;
      callback();
    });
  };

  const getState = () => isSticky;

  function handleScrollCb(e) {
    if (!shouldUpdate) return;

    let scrollPos = $(window).scrollTop();

    switch (isSticky) {
      case true:
        if (scrollPos < stickyLimit) {
          shouldUpdate = false;
          el.removeClass('is-sticky');
          isSticky = !isSticky;

          PubSub.publish('sticky:leave');
          shouldUpdate = true;
          return leaveSticky && leaveSticky();
        }
      break;

      case false:
        if (scrollPos > stickyLimit) {
          shouldUpdate = false;
          el.addClass('is-sticky');
          isSticky = !isSticky;

          PubSub.publish('sticky:enter');
          shouldUpdate = true;
          return enterSticky && enterSticky();
        }        
      break;
    }

    shouldUpdate = true;
  };

  bindScrollEvent();

  return {
    getState,
    scrollTop,
    destroy
  }
};


// WEBPACK FOOTER //
// ./src/components/header/stickyModule.js